import {IconProps} from './types';

const Lock = ({fill = 'currentColor', className, width = 16, height = 16}: IconProps) => (      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        fill="none"
        viewBox="0 0 16 16"
        className={className}
      >
        <g
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          clipPath="url(#clip0_20687_2987)"
        >
          <path d="M7.167 11.667H.5a4.667 4.667 0 0 1 7.333-3.83M10.167 10.5H14.5s1 0 1 1v3s0 1-1 1h-4.333s-1 0-1-1v-3s0-1 1-1"></path>
          <path d="M10 10.514V9.5a2.333 2.333 0 1 1 4.667 0v1.014M11.333 13l.667.667 1.333-1.334M2.713 1.854A4.57 4.57 0 0 0 7.81 2.878"></path>
          <path d="M2.333 3.25a2.75 2.75 0 1 0 5.5 0 2.75 2.75 0 0 0-5.5 0"></path>
        </g>
        <defs>
          <clipPath id="clip0_20687_2987">
            <path fill={fill} d="M0 0h16v16H0z"></path>
          </clipPath>
        </defs>
      </svg>
    );    

export default Lock;
